import { useFetchMessagesQuery } from './api/messagesApi';

export default function useMessageCounter() {
  const { data } = useFetchMessagesQuery(undefined,
    { refetchOnMountOrArgChange: true });
  
  return data ? data.filter((message) => message.isRead === 0).length : 0;
}
